import { render, staticRenderFns } from "./Facts.vue?vue&type=template&id=5f699a12&scoped=true&"
import script from "./Facts.vue?vue&type=script&lang=js&"
export * from "./Facts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f699a12",
  null
  
)

export default component.exports